import * as React from "react"

import { Dialog, DialogContent } from "@/components/ui/dialog"
import { Kbd } from "@/components/ui/stat-card"

const GROUPS: Array<{
  title: string
  items: Array<{ keys: string[]; desc: string }>
}> = [
  {
    title: "Move around",
    items: [
      { keys: ["j"], desc: "Next finding" },
      { keys: ["k"], desc: "Previous finding" },
      { keys: ["Enter"], desc: "Expand or collapse" },
      { keys: ["Escape"], desc: "Collapse the current finding" },
      { keys: ["/"], desc: "Search the rail" },
    ],
  },
  {
    title: "Disposition",
    items: [
      { keys: ["c"], desc: "Confirm — re-press to undo" },
      { keys: ["d"], desc: "Dismiss — re-press to undo" },
      { keys: ["s"], desc: "Send to a specialist — re-press to undo" },
      { keys: ["m"], desc: "Mark corrected (only when a fix is proposed)" },
      { keys: ["e"], desc: "Edit — only on findings you authored" },
    ],
  },
  {
    title: "Help",
    items: [{ keys: ["?"], desc: "This cheat sheet" }],
  },
]

export interface ReviewShortcutsProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function ReviewShortcuts({ open, onOpenChange }: ReviewShortcutsProps): JSX.Element {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        size="md"
        title="Keyboard shortcuts"
        description="Dispositioning a review is a repetitive task done for hours — the keyboard is faster."
      >
        <div className="grid gap-4">
          {GROUPS.map((g) => (
            <section key={g.title}>
              <h3 className="mb-2 font-id text-micro font-medium uppercase tracking-[0.08em] text-text-3">
                {g.title}
              </h3>
              <dl className="grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-2">
                {g.items.map((it, i) => (
                  <React.Fragment key={i}>
                    <dt className="flex gap-1">
                      {it.keys.map((k, j) => (
                        <Kbd key={j} keys={k} />
                      ))}
                    </dt>
                    <dd className="text-body-sm text-text-2">{it.desc}</dd>
                  </React.Fragment>
                ))}
              </dl>
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
